import { SectionDefinition, notFor, createProductsByKey } from "./product";

// Categories

const sach = {
    key: "sach",
    displayName: "GI Privatkunden",
    printName: "Privatkundenversicherung",
};
const leben = {
    key: "leben",
    displayName: "Life",
    printName: "Lebensversicherung",
};
const kraftfahrt = {
    key: "kraftfahrt",
    displayName: "Kraftfahrt",
    printName: "Kraftfahrtversicherung",
    icon: "zas-icon-drive",
};
const firmen = {
    key: "fk",
    displayName: "GI Firmenkunden",
    printName: "Firmenkundenversicherung",
};
const sme = {
    key: "sme",
    displayName: "Firmenschutz",
    printName: "Firmenschutzversicherung",
};

export const sonstige = {
    key: "zbdSonstige",
    displayName: "Sonstige",
    printName: "Sonstige",
};

// Sach

const unfall = {
    key: "unfall",
    displayName: "Unfall",
    printName: "Unfallversicherung",
    icon: "zas-icon-first-aid",
};
const haftpflicht = {
    key: "haftpflicht",
    displayName: "Haftpflicht",
    printName: "Haftpflichtversicherung",
    icon: "zas-icon-football",
};
const rechtsschutz = {
    key: "rechtsschutz",
    displayName: "Rechtsschutz",
    printName: "Rechtsschutzversicherung",
    icon: "zas-icon-law",
};
const hausrat = {
    key: "hausrat",
    displayName: "Hausrat",
    printName: "Hausratversicherung",
    icon: "zas-icon-lounge",
};
const wohngebaeude = {
    key: "wohngebaeude",
    displayName: "Wohngebäude",
    printName: "Wohngebäudeversicherung",
    icon: "zas-icon-house",
};
const mobilschutz = {
    key: "mobilschutz",
    displayName: "Mobilschutz",
    printName: "Mobilschutzversicherung",
    icon: "zas-icon-briefcase",
};
const bauherrenhaftpflicht = {
    key: "bauherrenhaftpflicht",
    displayName: "Bauherren-Haftpflicht",
    printName: "Bauherren-Haftpflichtversicherung",
    icon: "zas-icon-construction",
};
const jagdhaftpflicht = {
    key: "jagdhaftpflicht",
    displayName: "Jagd-Haftpflicht",
    printName: "Jagd-Haftpflichtversicherung",
    icon: "zas-icon-reindeer",
};
const nebengebaeude = {
    key: "nebengebaeude",
    displayName: "Nebengebäude",
    printName: "Nebengebäudeversicherung",
    icon: "zas-icon-property-investors",
};
const tresor = {
    key: "tresor",
    displayName: "Tresor",
    printName: "Tresorversicherung",
    icon: "zas-icon-bank-note",
};
const emobilschutz = {
    key: "emobilschutz",
    displayName: "E-MobilSchutz",
    printName: "E-MobilSchutz",
    icon: "zas-icon-e-bike",
};
const kraftfahrtSach = {
    key: "kraftfahrt",
    displayName: "Kraftfahrt",
    printName: "Kraftfahrtversicherung",
    icon: "zas-icon-home-motor",
};
const oldtimer = {
    key: "oldtimer",
    displayName: "Oldtimer",
    printName: "Oldtimer-Versicherung",
    icon: "zas-icon-home-motor",
};
const jungefahrer = {
    key: "jungefahrer",
    displayName: "Junge Fahrer Police",
    printName: "Junge Fahrer Police",
    icon: "zas-icon-jungefahrer",
};
const allgemeineGevos = {
    key: "allgemeineGevos",
    displayName: "Allgemeine Änderungen",
    printName: "Allgemeine Änderungen",
};
const hochzeit = {
    key: "hochzeit",
    displayName: "Hochzeitsversicherung",
    printName: "Hochzeitsversicherung",
    icon: "zas-icon-hochzeit",
};

// Leben
const PrivatGefoerderteAltersvorsorge = {
    key: "PrivatGefoerderteAltersvorsorge",
    displayName: "Privat geförderte Altersvorsorge",
    printName: "Privat geförderte Altersvorsorge",
};
const FondgebundeneProdukte = {
    key: "FondgebundeneProdukte",
    displayName: "Fondgebundene Produkte",
    printName: "Fondgebundene Produkte",
};
const KlassischeProdukte = {
    key: "KlassischeProdukte",
    displayName: "Klassische Produkte",
    printName: "Klassische Produkte",
};
const TodesfallvorsorgeUndPflege = {
    key: "TodesfallvorsorgeUndPflege",
    displayName: "Todesfallvorsorge und Pflege",
    printName: "Todesfallvorsorge und Pflege",
};
const Einkommenssicherung = {
    key: "Einkommenssicherung",
    displayName: "Einkommenssicherung",
    printName: "Einkommenssicherung",
};
const Direktversicherung = {
    key: "Direktversicherung",
    displayName: "Direktversicherung",
    printName: "Direktversicherung",
};
const BerufsunfaehigkeitsVorsorge = {
    key: "BerufsunfaehigkeitsVorsorge",
    displayName: "BerufsunfähigkeitsVorsorge",
    printName: "BerufsunfähigkeitsVorsorge",
};
const BerufsunfaehigkeitsSchutzbrief = {
    key: "BerufsunfaehigkeitsSchutzbrief",
    displayName: "Berufsunfähigkeits-Schutzbrief",
    printName: "Berufsunfähigkeits-Schutzbrief",
};
const DVBerufsunfaehigkeitsSchutzbrief = {
    key: "DVBerufsunfaehigkeitsSchutzbrief",
    displayName: "DV Berufsunfähigkeits-Schutzbrief",
    printName: "DV Berufsunfähigkeits-Schutzbrief",
};
const ZurichBerufsunfaehigkeitsVorsorge = {
    key: "ZurichBerufsunfaehigkeitsVorsorge",
    displayName: "Zurich Berufsunfähigkeits-Vorsorge",
    printName: "Zurich Berufsunfähigkeits-Vorsorge",
};
const ErwerbsunfaehigkeitsVorsorge = {
    key: "ErwerbsunfaehigkeitsVorsorge",
    displayName: "ErwerbsunfähigkeitsVorsorge",
    printName: "ErwerbsunfähigkeitsVorsorge",
};
const JuniorBU = {
    key: "JuniorBUPlus",
    displayName: "Junior BU+",
    printName: "Junior BU+",
};
const AusbildungsVorsorge = {
    key: "AusbildungsVorsorge",
    displayName: "Ausbildungs-Vorsorge",
    printName: "Ausbildungs-Vorsorge",
};
const ErwerbsunfaehigkeitsSchutzbrief = {
    key: "ErwerbsunfaehigkeitsSchutzbrief",
    displayName: "Erwerbsunfähigkeits-Schutzbrief",
    printName: "Erwerbsunfähigkeits-Schutzbrief",
};
const DVErwerbsunfaehigkeitsSchutzbrief = {
    key: "DVErwerbsunfaehigkeitsSchutzbrief",
    displayName: "DV Erwerbsunfähigkeits-Schutzbrief",
    printName: "DV Erwerbsunfähigkeits-Schutzbrief",
};
const GrundfaehigkeitsSchutzbrief = {
    key: "GrundfaehigkeitsSchutzbrief",
    displayName: "Grundfähigkeits-Schutzbrief",
    printName: "Grundfähigkeits-Schutzbrief",
};
const ZurichGrundfaehigkeitsVorsorge = {
    key: "ZurichGrundfaehigkeitsVorsorge",
    displayName: "Zurich Grundfähigkeits-Vorsorge",
    printName: "Zurich Grundfähigkeits-Vorsorge",
};
const RisikolebenKomfort = {
    key: "RisikoLebenKomfort",
    displayName: "RisikoLeben Komfort",
    printName: "RisikoLeben Komfort",
};
const VarioInvestBasisRente = {
    key: "VarioInvestBasisRente",
    displayName: "VarioInvest BasisRente",
    printName: "VarioInvest BasisRente",
};
const VarioInvestFoerderRente = {
    key: "VarioInvestFoerderRente",
    displayName: "VarioInvest FörderRente",
    printName: "VarioInvest FörderRente",
};
const VarioInvestRente = {
    key: "VarioInvestRente",
    displayName: "VarioInvest Rente",
    printName: "VarioInvest Rente",
};
const DVVarioInvestRente = {
    key: "DVVarioInvestRente",
    displayName: "DV VarioInvest Rente",
    printName: "DV VarioInvest Rente",
};
const Vorsorgeinvest = {
    key: "Vorsorgeinvest",
    displayName: "Vorsorgeinvest",
    printName: "Vorsorgeinvest",
};
const DVVorsorgeinvest = {
    key: "DVVorsorgeinvest",
    displayName: "DV Vorsorgeinvest",
    printName: "DV Vorsorgeinvest",
};
const VorsorgeinvestGegenEinmalbeitrag = {
    key: "VorsorgeinvestGegenEinmalbeitrag",
    displayName: "Vorsorgeinvest gegen Einmalbeitrag",
    printName: "Vorsorgeinvest gegen Einmalbeitrag",
};
const ZurichVorsorgeFlex = {
    key: "ZurichVorsorgeFlex",
    displayName: "Zurich VorsorgeFlex",
    printName: "Zurich VorsorgeFlex",
};
const Renteclassic = {
    key: "Renteclassic",
    displayName: "Renteclassic",
    printName: "Renteclassic",
};
const DVRenteclassic = {
    key: "DV Renteclassic",
    displayName: "DV Renteclassic",
    printName: "DV Renteclassic",
};
const DepotRenteclassic = {
    key: "DepotRenteclassic",
    displayName: "Depot Renteclassic",
    printName: "Depot Renteclassic",
};
const RenteclassicSelect = {
    key: "RenteclassicSelect",
    displayName: "Renteclassic select",
    printName: "Renteclassic select",
};
const DVRenteclassicSelect = {
    key: "DVRenteclassicSelect",
    displayName: "DV Renteclassic select",
    printName: "DV Renteclassic select",
};
const SofortRenteclassicSelect = {
    key: "SofortRenteclassicSelect",
    displayName: "Sofort Renteclassic select",
    printName: "Sofort Renteclassic select",
};
const SofortRenteclassic = {
    key: "SofortRenteclassic",
    displayName: "Sofort Renteclassic",
    printName: "Sofort Renteclassic",
};
const Juniorinvest = {
    key: "Juniorinvest",
    displayName: "Juniorinvest",
    printName: "Juniorinvest",
};
const JuniorinvestGegenEinmalbeitrag = {
    key: "JuniorinvestGegenEinmalbeitrag",
    displayName: "Juniorinvest gegen Einmalbeitrag",
    printName: "Juniorinvest gegen Einmalbeitrag",
};
const VarioInvestRenteGegenEinmalbeitrag = {
    key: "VarioInvestRenteGegenEinmalbeitrag",
    displayName: "VarioInvest Rente gegen Einmalbeitrag",
    printName: "VarioInvest Rente gegen Einmalbeitrag",
};
const BasisRenteinvest = {
    key: "BasisRenteinvest",
    displayName: "Basis Renteinvest",
    printName: "Basis Renteinvest",
};
const VarioInvestBasisRenteGegenEinmalbeitrag = {
    key: "VarioInvestBasisRenteGegenEinmalbeitrag",
    displayName: "VarioInvest BasisRente gegen Einmalbeitrag",
    printName: "VarioInvest BasisRente gegen Einmalbeitrag",
};
const BasisRenteinvestGegenEinmalbeitrag = {
    key: "BasisRenteinvestGegenEinmalbeitrag",
    displayName: "Basis Renteinvest gegen Einmalbeitrag",
    printName: "Basis Renteinvest gegen Einmalbeitrag",
};

const Baufinanzierung = {
    key: "Baufinanzierung",
    displayName: "Baufinanzierung",
    printName: "Baufinanzierung",
};
const BaufinanzierungsSchutzKomfort = {
    key: "BaufinanzierungsSchutzKomfort",
    displayName: "BaufinanzierungsSchutz Komfort",
    printName: "BaufinanzierungsSchutz Komfort",
};

const BaufinanzierungsSchutzBasis = {
    key: "BaufinanzierungsSchutzBasis",
    displayName: "BaufinanzierungsSchutz Basis",
    printName: "BaufinanzierungsSchutz Basis",
};

// Kraftfahrt
const standardTarif = {
    key: "standardTarif",
    displayName: "Standard-Tarif",
    printName: "Standard-Tarif",
};
const basisTarif = {
    key: "basisTarif",
    displayName: "Basis-Tarif",
    printName: "Basis-Tarif",
};
const topTarif = {
    key: "topTarif",
    displayName: "Top-Tarif",
    printName: "Top-Tarif",
};
const topTarifSchadenskomfort = {
    key: "topTarifSchadenskomfort",
    displayName: "Top-Tarif inkl. Schadenskomfortschutz",
    printName: "Top-Tarif inkl. Schadenskomfortschutz",
};
const fahrzeugVoll = {
    key: "fahrzeugVoll",
    displayName: "Fahrzeug-Vollversicherung",
    printName: "Fahrzeug-Vollversicherung",
};
const fahrzeugTeil = {
    key: "fahrzeugTeil",
    displayName: "Fahrzeug-Teilversicherung (Kasko)",
    printName: "Fahrzeug-Teilversicherung (Kasko)",
};
const werkstattPlus = {
    key: "werkstattPlus",
    displayName: "Werkstatt-Plus",
    printName: "Werkstatt-Plus-Versicherung",
};
const insassenUnfall = {
    key: "insassenUnfall",
    displayName: "Insassenunfallversicherung",
    printName: "Insassenunfallversicherung",
};
const khPlus = {
    key: "khPlus",
    displayName: "KH-Plus",
    printName: "KH-Plus-Versicherung",
};
const schutzbrief = {
    key: "schutzbrief",
    displayName: "Schutzbrief",
    printName: "Schutzbrief",
};
const umd = {
    key: "umd",
    displayName: "Unfallmeldedienst (UMD)",
    printName: "Unfallmeldedienst (UMD)",
};

// Firmenkunden

const fkHaftpflicht = {
    key: "fkHaftpflicht",
    displayName: "Haftpflicht",
    printName: "Haftpflichtversicherung",
};
const fkKfz = {
    key: "fkKfz",
    displayName: "Kraftfahrzeugversicherung",
    printName: "Kraftfahrzeugversicherung",
};
const fkSach = {
    key: "fkSach",
    displayName: "Sachversicherung",
    printName: "Sachversicherung",
};
const fkTechnisch = {
    key: "fkTechnisch",
    displayName: "Technische Versicherungen",
    printName: "Technische Versicherungen",
};
const fkGruppen = {
    key: "fkGruppen",
    displayName: "Gruppenunfallversicherung",
    printName: "Gruppenunfallversicherung",
};
const bav = {
    key: "bav",
    displayName: "Betriebliche Altersversorgung",
    printName: "Betriebliche Altersversorgung",
};
const fkRechtsschutz = {
    key: "fkRechtsschutz",
    displayName: "Firmenrechtsschutzversicherung",
    printName: "Firmenrechtsschutzversicherung",
};
const fkTransportschutz = {
    key: "fkTransportschutz",
    displayName: "Firmentransportschutzversicherung",
    printName: "Firmentransportschutzversicherung",
};
const dritt = {
    key: "dritt",
    displayName: "Drittanbieter",
    printName: "Drittanbieter",
};
const fkSonstige = {
    key: "fkSonstige",
    displayName: "Sonstige Versicherungen",
    printName: "Sonstige Versicherungen",
};

// firmenschutz (haft)

const smeHaft = {
    key: "smehaftpflicht",
    displayName: "Haftpflicht",
    printName: "Haftpflichtversicherung",
    icon: "zas-icon-first-aid",
};

const smeBetriebHaft = {
    key: "betriebhaft",
    displayName: "Betriebshaftpflicht",
    printName: "FirmenSchutz Haftpflichtversicherung",
    icon: "zas-icon-drill-wall",
};

const smeBauherren = {
    key: "bauherren",
    displayName: "Bauherren-Haftpflicht",
    printName: "FirmenSchutz Bauherren-Haftpflichtversicherung",
    icon: "zas-icon-constructor",
};

const smeHausUndGrund = {
    key: "hausundgrund",
    displayName: "Haus- und Grundbesitzer-Haftpflicht",
    printName: "FirmenSchutz Haus- und Grundbesitzer-Haftpflichtversicherung",
    icon: "zas-icon-property-investors",
};

const smeVeranstalter = {
    key: "veranstalter",
    displayName: "Veranstalter-Haftpflicht",
    printName: "FirmenSchutz Veranstalter-Haftpflichtversicherung",
    icon: "zas-icon-ticket",
};

// firmenschutz (sach)

const smeSach = {
    key: "smeSach",
    displayName: "Sach",
    printName: "Sachversicherung",
    icon: "zas-icon-signal-light",
};

const smeWohngebaeude = {
    key: "smewohngebaeude",
    displayName: "Wohngebäude (Mehrfamilienhäuser)",
    printName: "FirmenSchutz Wohngebäudeversicherung (Mehrfamilienhäuser)",
    icon: "zas-icon-wohngebaeude",
};

const smeGewGebaeude = {
    key: "smegewgebaeude",
    displayName: "Gebäudeversicherung",
    printName: "FirmenSchutz Sachversicherung (Gebäudeversicherung)",
    icon: "zas-icon-first-aid",
};

const smeInhalt = {
    key: "smeinhalt",
    displayName: "Inhaltsversicherung",
    printName: "FirmenSchutz Sachversicherung (Inhaltsversicherung)",
    icon: "zas-icon-first-aid",
};

const smeErtrag = {
    key: "inhaltundertrag",
    displayName: "Ertragsausfallversicherung",
    printName: "FirmenSchutz Sachversicherung (Ertragsausfallversicherung)",
    icon: "zas-icon-signal-light",
};

const smeKleinBU = {
    key: "smekleinbu",
    displayName: "Klein-BU Versicherung",
    printName:
        "FirmenSchutz Sachversicherung (Klein-Betriebsunterbrechungsversicherung)",
    icon: "zas-icon-first-aid",
};

const smeBetriebsschliessung = {
    key: "betriebsschliessung",
    displayName: "Betriebsschließungsversicherung",
    printName:
        "FirmenSchutz Sachversicherung (Betriebsschließungsversicherung)",
    icon: "zas-icon-first-aid",
};

// firmenschutz (TR)

const smeTransport = {
    key: "transport",
    displayName: "Transportversicherung",
    printName: "Transportversicherung",
    icon: "zas-icon-first-aid",
};

const smeAutoinhalt = {
    key: "autoinhalt",
    displayName: "Autoinhalt",
    printName: "FirmenSchutz Autoinhaltsversicherung",
    icon: "zas-icon-autoinhalt",
};

const smeFrachtfuehrer = {
    key: "frachtfuehrer",
    displayName: "Frachtführer",
    printName: "FirmenSchutz Frachtführerversicherung",
    icon: "zas-icon-frachtfuehrer",
};

const smeWarentransportEinmalig = {
    key: "warentransporteinmalig",
    displayName: "Warentransport (Einmalvertrag)",
    printName: "FirmenSchutz Warentransportversicherung (Einmalvertrag)",
    icon: "zas-icon-warentransport",
};

const smeWarentransportJahresvertrag = {
    key: "warentransportjahresvertrag",
    displayName: "Warentransport (Jahresvertrag)",
    printName: "FirmenSchutz Warentransportversicherung (Jahresvertrag)",
    icon: "zas-icon-warentransport",
};

// firmenschutz (TV)

const smeTech = {
    key: "smeTech",
    displayName: "Technische Versicherung",
    printName: "Technische Versicherung",
    icon: "zas-icon-first-aid",
};

const smeElektronik = {
    key: "elektronik",
    displayName: "Elektronik",
    printName: "FirmenSchutz Elektronikversicherung",
    icon: "zas-icon-elektronik",
};

const smeMaschinenFahrbar = {
    key: "maschinenfahrbar",
    displayName: "Maschine fahrbar",
    printName:
        "FirmenSchutz Maschinen- und Kaskoversicherung von fahrbren oder transportablen Geräten",
    icon: "zas-icon-maschine-fahrbar",
};

const smeMaschinenStationaer = {
    key: "maschinenstationaer",
    displayName: "Maschine stationär",
    printName: "FirmenSchutz Maschinenversicherung von stationären Maschinen",
    icon: "zas-icon-maschine-stationaer",
};

const smeBauleistung = {
    key: "bauleistung",
    displayName: "Bauleistungsversicherung",
    printName: "FirmenSchutz Bauleistungsversicherung",
    icon: "zas-icon-first-aid",
};

// firmenschutz (rechtsschutz)

const smeRechtsschutz = {
    key: "smeRechtsschutz",
    displayName: "Rechtsschutz",
    printName: "Rechtsschutz",
    icon: "zas-icon-law",
};

const smeRechtsschutzPaket = {
    key: "smerspaket28",
    displayName: "Firmen-Rechtsschutz-Paket § 28",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Firmen-Rechtsschutz-Paket § 28)",
    icon: "zas-icon-first-aid",
};

const smeRechtsschutzPaketFuerArzteApothekerUndHeilberufe = {
    key: "smersaerzteapothekerheilberufe",
    displayName:
        "Firmen-Rechtsschutz-Paket für niedergelassene Ärzte, Apotheker und Heilberufe § 28 a",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Firmen-Rechtsschutz-Paket für niedergelassene Ärzte, Apotheker und Heilberufe § 28 a)",
    icon: "zas-icon-first-aid",
};

const smeRechtsschutzPaketFuerVereine = {
    key: "smersvereine",
    displayName: "Firmen-Rechtsschutz-Paket für Vereine § 28 b",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Firmen-Rechtsschutz-Paket für Vereine § 28 b)",
    icon: "zas-icon-first-aid",
};

const smeRechtsschutzPaketFuerKfzGewerbeUndFahrschulen = {
    key: "smerskfzgewerbefahrschulen",
    displayName:
        "Firmen-Rechtsschutz-Paket für das Kfz-Gewerbe und Fahrschulen § 28 c",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Firmen-Rechtsschutz-Paket für das Kfz-Gewerbe und Fahrschulen § 28 c)",
    icon: "zas-icon-first-aid",
};

const smeRechtsschutzPaketFuerFuhrUndTransportbetriebe = {
    key: "smersfuhrtransportbetriebe",
    displayName: "Firmen-Rechtsschutz-Paket für Fuhr-/Transportbetriebe § 28 d",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Firmen-Rechtsschutz-Paket für Fuhr-/Transportbetriebe § 28 d)",
    icon: "zas-icon-first-aid",
};

const smeFirmenRechtsschutz = {
    key: "smefrs24",
    displayName: "Firmen-Rechtsschutz § 24",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Firmen-Rechtsschutz § 24)",
    icon: "zas-icon-first-aid",
};

const smePrivatRechtsschutz = {
    key: "smeprs23",
    displayName: "Privat-Rechtsschutz § 23",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Privat-Rechtsschutz § 23)",
    icon: "zas-icon-first-aid",
};

const smeVerkehrsRechtsschutzAbs1 = {
    key: "smersverkehr21abs1",
    displayName: "Verkehrs-Rechtsschutz § 21 Abs. 1",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Verkehrs-Rechtsschutz § 21 Abs. 1)",
    icon: "zas-icon-first-aid",
};

const smeVerkehrsRechtsschutzAbs3 = {
    key: "smersverkehr21abs3",
    displayName: "Verkehrs-Rechtsschutz § 21 Abs. 3",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Verkehrs-Rechtsschutz § 21 Abs. 3)",
    icon: "zas-icon-first-aid",
};

const smeLandwirtschaftsUndVerkehrsRechtsschutz = {
    key: "smerslandverkehr27",
    displayName: "Landwirtschafts- und Verkehrs-Rechtsschutz § 27",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Landwirtschafts- und Verkehrs-Rechtsschutz § 27)",
    icon: "zas-icon-first-aid",
};

const smeImmobilienRechtsschutz = {
    key: "smersimmobilien29",
    displayName: "Immobilien-Rechtsschutz § 29",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Immobilien-Rechtsschutz § 29)",
    icon: "zas-icon-first-aid",
};

const smeSpezialStrafRechtsschutz = {
    key: "smersspezialstraffirmenindustrie",
    displayName: "Spezial-Straf-Rechtsschutz für Firmen und Industrie",
    printName:
        "FirmenSchutz Rechtsschutzversicherung (Spezial-Straf-Rechtsschutz für Firmen und Industrie)",
    icon: "zas-icon-first-aid",
};

// firmenschutz (gruppenunfall)
const smeGruppenunfall = {
    key: "smegruppenunfall",
    displayName: "Gruppen-Unfall",
    printName: "FirmenSchutz Gruppen-Unfallversicherung",
    icon: "zas-icon-gruppenunfall",
};

const riskSach = "Risiko";
const riskPerson = "Versicherte Person";

export const productDefinitions: SectionDefinition = {
    name: {
        key: "products",
        displayName: "Produkte",
        printName: "verfügbare Produkte",
    },
    multi: false,
    visibility: null,
    sections: [
        {
            name: sach,
            multi: true,
            visibility: null,
            sections: [
                {
                    name: kraftfahrt,
                    multi: true,
                    visibility: notFor("DB", "DA-GST"),
                    sections: [
                        {
                            name: standardTarif,
                            line: standardTarif,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: basisTarif,
                            line: basisTarif,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: topTarif,
                            line: topTarif,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: topTarifSchadenskomfort,
                            line: topTarifSchadenskomfort,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: fahrzeugVoll,
                            line: fahrzeugVoll,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: fahrzeugTeil,
                            line: fahrzeugTeil,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: werkstattPlus,
                            line: werkstattPlus,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: insassenUnfall,
                            line: insassenUnfall,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: khPlus,
                            line: khPlus,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: schutzbrief,
                            line: schutzbrief,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: umd,
                            line: umd,
                            category: kraftfahrt,
                            application: "Kraftfahrt",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: haftpflicht,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "privathaftpflicht",
                                displayName: "Privat-Haftpflicht",
                                printName: "Private Haftpflichtversicherung",
                            },
                            line: haftpflicht,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "tierhalterhaftpflicht",
                                displayName: "Tierhalter-Haftpflicht",
                                printName: "Tierhalter-Haftpflichtversicherung",
                            },
                            line: haftpflicht,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "sportbootehaftpflicht",
                                displayName: "Sportboot-Haftpflicht",
                                printName: "Sportboot-Haftpflichtversicherung",
                            },
                            line: haftpflicht,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "gewaesserschadenhaftpflicht",
                                displayName: "Gewässerschaden-Haftpflicht",
                                printName:
                                    "Gewässerschaden-Haftpflichtversicherung",
                            },
                            line: haftpflicht,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "hausbesitzerhaftpflicht",
                                displayName:
                                    "Haus- und Grundbesitzer-Haftpflicht",
                                printName:
                                    "Haus- und Grundbesitzer-Haftpflichtversicherung",
                            },
                            line: haftpflicht,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },

                {
                    name: rechtsschutz,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "privatrechtsschutz",
                                displayName: "Privat- und Berufs-Rechtsschutz",
                                printName:
                                    "Privat- und Berufs-Rechtsschutzversicherung",
                            },
                            line: rechtsschutz,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "familienverkehrsrechtsschutz",
                                displayName: "Verkehrs-Rechtsschutz",
                                printName: "Verkehrs-Rechtsschutzversicherung",
                            },
                            line: rechtsschutz,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "verkehrsrechtsschutz",
                                displayName: "Verkehrs-Rechtsschutz (MIG)",
                                printName: "Verkehrs-Rechtsschutzversicherung",
                            },
                            line: rechtsschutz,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: (_) => false, // never displayed in UI, used to generate list in ZBD Admin
                        },
                        {
                            name: {
                                key: "immobilienrechtsschutz",
                                displayName: "Immobilien-Rechtsschutz",
                                printName:
                                    "Immobilien-Rechtsschutzversicherung",
                            },
                            line: rechtsschutz,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "erweiterterstrafrechtsschutz",
                                displayName: "Erweiterter Straf-Rechtsschutz",
                                printName:
                                    "Erweiterter Straf-Rechtsschutzversicherung",
                            },
                            line: rechtsschutz,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: emobilschutz,
                    multi: false,
                    visibility: notFor("BoFi", "DA", "DB"),
                    sections: [
                        {
                            name: {
                                key: "emobilschutzmitvkz",
                                displayName: "Fahrzeug mit VKZ (bis 2019)",
                                printName: "Fahrzeug mit VKZ",
                            },
                            line: emobilschutz,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "emobilschutzmitvkz2020",
                                displayName: "Fahrzeug mit VKZ",
                                printName: "Fahrzeug mit VKZ",
                            },
                            line: emobilschutz,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "emobilschutzohnevkz",
                                displayName: "Fahrzeug ohne VKZ",
                                printName: "Fahrzeug ohne VKZ",
                            },
                            line: emobilschutz,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "emobilschutzhaftpflicht",
                                displayName: "Haftpflicht",
                                printName: "E-MobilSchutz Haftpflicht",
                            },
                            line: emobilschutz,
                            category: sach,
                            application: "ZAS",
                            riskName: riskSach,
                            multi: false,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: unfall,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "privatunfall",
                                displayName: "Private Unfallversicherung",
                                printName: "Private Unfallversicherung",
                            },
                            line: unfall,
                            category: sach,
                            application: "ZAS",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fiv",
                                displayName: "Existenzversicherung",
                                printName: "Existenzversicherung",
                            },
                            line: unfall,
                            category: sach,
                            application: "ZAS",
                            riskName: riskPerson,
                            multi: true,
                            visibility: notFor("DB"),
                        },
                    ],
                },
                {
                    name: hausrat,
                    line: hausrat,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: wohngebaeude,
                    line: wohngebaeude,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: true,
                    visibility: notFor("DA", "DB"),
                },
                {
                    name: mobilschutz,
                    line: mobilschutz,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: false,
                    visibility: notFor("DA", "DB"),
                },
                {
                    name: bauherrenhaftpflicht,
                    line: bauherrenhaftpflicht,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: false,
                    visibility: null,
                },
                {
                    name: jagdhaftpflicht,
                    line: jagdhaftpflicht,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: false,
                    visibility: null,
                },
                {
                    name: nebengebaeude,
                    line: nebengebaeude,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: true,
                    visibility: notFor("DA", "DB"),
                },
                {
                    name: tresor,
                    line: tresor,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: true,
                    visibility: notFor("DA", "DB-FB", "ZEP", "BoFi"),
                },

                {
                    name: kraftfahrtSach,
                    line: kraftfahrtSach,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: oldtimer,
                    line: oldtimer,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: jungefahrer,
                    line: jungefahrer,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: true,
                    visibility: null, // () => config.FLAGS && config.FLAGS.includes("JUNGE_FAHRER"),
                },
                {
                    name: allgemeineGevos,
                    line: allgemeineGevos,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: false,
                    visibility: (_) => false,
                },
                {
                    name: hochzeit,
                    line: hochzeit,
                    category: sach,
                    application: "ZAS",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
            ],
        },
        {
            name: leben,
            multi: false,
            visibility: notFor("DA", "DB"),
            sections: [
                {
                    name: PrivatGefoerderteAltersvorsorge,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: VarioInvestBasisRente,
                            line: VarioInvestBasisRente,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: VarioInvestFoerderRente,
                            line: VarioInvestFoerderRente,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: BasisRenteinvest,
                            line: BasisRenteinvest,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: VarioInvestBasisRenteGegenEinmalbeitrag,
                            line: VarioInvestBasisRenteGegenEinmalbeitrag,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: BasisRenteinvestGegenEinmalbeitrag,
                            line: BasisRenteinvestGegenEinmalbeitrag,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: FondgebundeneProdukte,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: VarioInvestRente,
                            line: VarioInvestRente,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: Vorsorgeinvest,
                            line: Vorsorgeinvest,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: VorsorgeinvestGegenEinmalbeitrag,
                            line: VorsorgeinvestGegenEinmalbeitrag,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: Juniorinvest,
                            line: Juniorinvest,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: JuniorinvestGegenEinmalbeitrag,
                            line: JuniorinvestGegenEinmalbeitrag,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: VarioInvestRenteGegenEinmalbeitrag,
                            line: VarioInvestRenteGegenEinmalbeitrag,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: ZurichVorsorgeFlex,
                            line: ZurichVorsorgeFlex,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: KlassischeProdukte,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: Renteclassic,
                            line: Renteclassic,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (ui, cp) =>
                                !cp ||
                                (cp.Customer.Address.Country &&
                                    cp.Customer.Address.Country !== "tc_AT"),
                        },
                        {
                            name: RenteclassicSelect,
                            line: RenteclassicSelect,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (_) => false,
                        },
                        {
                            name: DepotRenteclassic,
                            line: DepotRenteclassic,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: SofortRenteclassicSelect,
                            line: SofortRenteclassicSelect,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (_) => false,
                        },
                        {
                            name: SofortRenteclassic,
                            line: SofortRenteclassic,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: TodesfallvorsorgeUndPflege,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: RisikolebenKomfort,
                            line: RisikolebenKomfort,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: Einkommenssicherung,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: BerufsunfaehigkeitsVorsorge,
                            line: BerufsunfaehigkeitsVorsorge,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (_) => false, // never displayed in UI, used to generate list in ZBD Admin
                        },
                        {
                            name: BerufsunfaehigkeitsSchutzbrief,
                            line: BerufsunfaehigkeitsSchutzbrief,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (ui, cp) =>
                                !cp ||
                                (cp.Customer.Address.Country &&
                                    cp.Customer.Address.Country !== "tc_AT"),
                        },
                        {
                            name: JuniorBU,
                            line: JuniorBU,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (ui, cp) =>
                                !cp ||
                                (cp.Customer.Address.Country &&
                                    cp.Customer.Address.Country === "tc_DE"),
                        },
                        {
                            name: ZurichBerufsunfaehigkeitsVorsorge,
                            line: ZurichBerufsunfaehigkeitsVorsorge,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (ui, cp) =>
                                !cp ||
                                (cp.Customer.Address.Country &&
                                    cp.Customer.Address.Country === "tc_AT"),
                        },
                        {
                            name: AusbildungsVorsorge,
                            line: AusbildungsVorsorge,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (ui, cp) =>
                                !cp ||
                                (cp.Customer.Address.Country &&
                                    cp.Customer.Address.Country === "tc_AT"),
                        },
                        {
                            name: ZurichGrundfaehigkeitsVorsorge,
                            line: ZurichGrundfaehigkeitsVorsorge,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (ui, cp) =>
                                !cp ||
                                (cp.Customer.Address.Country &&
                                    cp.Customer.Address.Country === "tc_AT"),
                        },
                        {
                            name: ErwerbsunfaehigkeitsVorsorge,
                            line: ErwerbsunfaehigkeitsVorsorge,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: ErwerbsunfaehigkeitsSchutzbrief,
                            line: ErwerbsunfaehigkeitsSchutzbrief,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (ui, cp) =>
                                !cp ||
                                (cp.Customer.Address.Country &&
                                    cp.Customer.Address.Country !== "tc_AT"),
                        },
                        {
                            name: GrundfaehigkeitsSchutzbrief,
                            line: GrundfaehigkeitsSchutzbrief,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (ui, cp) =>
                                !cp ||
                                (cp.Customer.Address.Country &&
                                    cp.Customer.Address.Country !== "tc_AT"),
                        },
                    ],
                },
                {
                    name: Direktversicherung,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: DVRenteclassic,
                            line: DVRenteclassic,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (ui, cp) =>
                                !cp ||
                                (cp.Customer.Address.Country &&
                                    cp.Customer.Address.Country !== "tc_AT"),
                        },
                        {
                            name: DVRenteclassicSelect,
                            line: DVRenteclassicSelect,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: (_) => false,
                        },
                        {
                            name: DVBerufsunfaehigkeitsSchutzbrief,
                            line: DVBerufsunfaehigkeitsSchutzbrief,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: DVErwerbsunfaehigkeitsSchutzbrief,
                            line: DVErwerbsunfaehigkeitsSchutzbrief,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: DVVarioInvestRente,
                            line: DVVarioInvestRente,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: DVVorsorgeinvest,
                            line: DVVorsorgeinvest,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: Baufinanzierung,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: BaufinanzierungsSchutzKomfort,
                            line: BaufinanzierungsSchutzKomfort,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: BaufinanzierungsSchutzBasis,
                            line: BaufinanzierungsSchutzBasis,
                            category: leben,
                            application: "WebLife",
                            riskName: riskPerson,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
            ],
        },
        {
            name: firmen,
            multi: true,
            visibility: notFor("DA", "DB"),
            sections: [
                {
                    name: fkHaftpflicht,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "fkBerufshaftpflicht",
                                displayName: "Berufs-/Betriebshaftpflicht",
                                printName:
                                    "Berufs-/Betriebshaftpflichtversicherung",
                            },
                            line: fkHaftpflicht,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkUmwelthaftpflicht",
                                displayName: "Umwelthaftpflicht",
                                printName: "Umwelthaftpflicht",
                            },
                            line: fkHaftpflicht,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkVermoegenschadenhaftpflicht",
                                displayName: "Vermögensschaden-Haftpflicht",
                                printName:
                                    "Vermögensschaden-Haftpflichtversicherung",
                            },
                            line: fkHaftpflicht,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: fkKfz,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "fkKfzHaftpflicht",
                                displayName: "Haftpflicht",
                                printName: "Haftpflichtversicherung",
                            },
                            line: fkKfz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkKfzVollkasko",
                                displayName: "Vollkasko",
                                printName: "Vollkasko-Versicherung",
                            },
                            line: fkKfz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkKfzTeilkasko",
                                displayName: "Teilkasko",
                                printName: "Teilkasko-Versicherung",
                            },
                            line: fkKfz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkKfzInsassenunfall",
                                displayName: "Insassenunfall",
                                printName: "Insassenunfallversicherung",
                            },
                            line: fkKfz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkKfzFlottenvertrag",
                                displayName: "Flottenvertrag",
                                printName: "Flottenvertragsversicherung",
                            },
                            line: fkKfz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: fkSach,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "fkBetriebsgebaeude",
                                displayName: "Betriebsgebäude",
                                printName: "Betriebsgebäudeversicherung",
                            },
                            line: fkSach,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkBetriebseinrichtungen",
                                displayName:
                                    "Betriebseinrichtungen (techn. u. kaufm.)",
                                printName:
                                    "Betriebseinrichtungen (techn. u. kaufm.)",
                            },
                            line: fkSach,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkWaren",
                                displayName: "Rohstoffe/Waren/Vorräte",
                                printName:
                                    "Rohstoffe/Waren/Vorräte-Versicherung",
                            },
                            line: fkSach,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkErtragsausfall",
                                displayName: "Ertragsausfall",
                                printName: "Ertragsausfallversicherung",
                            },
                            line: fkSach,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkGlas",
                                displayName: "Glas",
                                printName: "Glasversicherung",
                            },
                            line: fkSach,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkBetriebsschliessung",
                                displayName: "Betriebsschließung",
                                printName: "Betriebsschließungsversicherung",
                            },
                            line: fkSach,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkGeschaeftshaus",
                                displayName:
                                    "Mehrfamilienhaus/Wohn- und Geschäftshaus",
                                printName:
                                    "Mehrfamilienhaus/Wohn- und Geschäftshaus",
                            },
                            line: fkSach,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkMietverlust",
                                displayName: "Mietverlust",
                                printName: "Mietverlust",
                            },
                            line: fkSach,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: fkGruppen,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "fkInvaliditaet",
                                displayName: "Invalidität",
                                printName: "Invalidität",
                            },
                            line: fkGruppen,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkRente",
                                displayName: "Rente",
                                printName: "Rente",
                            },
                            line: fkGruppen,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTod",
                                displayName: "Tod",
                                printName: "Tod",
                            },
                            line: fkGruppen,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkUnfallKTG",
                                displayName: "Unfallkrankentagegeld",
                                printName: "Unfallkrankentagegeld",
                            },
                            line: fkGruppen,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: fkTechnisch,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "fkElektronischeAnlagen",
                                displayName:
                                    "Elektronische Einrichtung/Anlagen und Geräte",
                                printName:
                                    "Elektronische Einrichtung/Anlagen und Geräte",
                            },
                            line: fkTechnisch,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkMaschinelleEinrichtung",
                                displayName: "Maschinelle Einrichtung",
                                printName: "Maschinelle Einrichtung",
                            },
                            line: fkTechnisch,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkFahrbareGeraete",
                                displayName: "Fahrbare Geräte (Baugeräte)",
                                printName: "Fahrbare Geräte (Baugeräte)",
                            },
                            line: fkTechnisch,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkBauleistung",
                                displayName: "Bauleistung",
                                printName: "Bauleistung",
                            },
                            line: fkTechnisch,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkMontage",
                                displayName: "Montage",
                                printName: "Montage",
                            },
                            line: fkTechnisch,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkBetriebsunterbrechung",
                                displayName: "Betriebsunterbrechung",
                                printName: "Betriebsunterbrechung",
                            },
                            line: fkTechnisch,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: fkRechtsschutz,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "fkRsStraf",
                                displayName: "Strafrechtsschutz",
                                printName: "Strafrechtsschutz",
                            },
                            line: fkRechtsschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkRsSchadenersatz",
                                displayName: "Schadenersatzrechtsschutz",
                                printName: "Schadenersatzrechtsschutz",
                            },
                            line: fkRechtsschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkRsArbeit",
                                displayName: "Arbeitsrechtsschutz",
                                printName: "Arbeitsrechtsschutz",
                            },
                            line: fkRechtsschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkRsSozialgericht",
                                displayName: "Sozialgerichtsrechtsschutz",
                                printName: "Sozialgerichtsrechtsschutz",
                            },
                            line: fkRechtsschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkRsSteuer",
                                displayName: "Steuerrechtsschutz",
                                printName: "Steuerrechtsschutz",
                            },
                            line: fkRechtsschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkRsVerkehr",
                                displayName: "Verkehrsrechtsschutzversicherung",
                                printName: "Verkehrsrechtsschutzversicherung",
                            },
                            line: fkRechtsschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkRsImmobilien",
                                displayName:
                                    "Immobilienrechtsschutzversicherung",
                                printName: "Immobilienrechtsschutzversicherung",
                            },
                            line: fkRechtsschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkRsSozialrecht",
                                displayName: "Sozialrechtsschutzversicherung",
                                printName: "Sozialrechtsschutzversicherung",
                            },
                            line: fkRechtsschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: fkTransportschutz,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "fkTsAusstJahr",
                                displayName:
                                    "Ausstellungs-Versicherung Jahresvertrag",
                                printName:
                                    "Ausstellungs-Versicherung Jahresvertrag",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTsAusstEinm",
                                displayName:
                                    "Ausstellungs-Versicherung Einmalvertrag",
                                printName:
                                    "Ausstellungs-Versicherung Einmalvertrag",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTsAutoinhalt",
                                displayName: "Autoinhalts-Versicherung",
                                printName: "Autoinhalts-Versicherung",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTsFrachtf",
                                displayName: "Frachtführer-Versicherung",
                                printName: "Frachtführer-Versicherung",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTsHakenlast",
                                displayName: "Hakenlast-Versicherung",
                                printName: "Hakenlast-Versicherung",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTsSoundsMore",
                                displayName:
                                    "Pauschal-Versicherung „Sounds & More“",
                                printName:
                                    "Pauschal-Versicherung „Sounds & More“",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTsReisegepaeck",
                                displayName:
                                    "Reisegepäck-Versicherung für Firmen",
                                printName:
                                    "Reisegepäck-Versicherung für Firmen",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTsReiserueck",
                                displayName:
                                    "Reiserücktrittskosten-Versicherung für Firmen",
                                printName:
                                    "Reiserücktrittskosten-Versicherung für Firmen",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTsWarenJahr",
                                displayName:
                                    "Warentransport-Versicherung Jahresvertrag",
                                printName:
                                    "Warentransport-Versicherung Jahresvertrag",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkTsWarenEinm",
                                displayName:
                                    "Warentransport-Versicherung für Einzeltransporte",
                                printName:
                                    "Warentransport-Versicherung für Einzeltransporte",
                            },
                            line: fkTransportschutz,
                            category: firmen,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: fkSonstige,
                    line: fkSonstige,
                    category: firmen,
                    application: "FK",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
            ],
        },
        {
            name: sme,
            multi: true,
            visibility: () =>
                config.FLAGS && config.FLAGS.includes("FIRMENSCHUTZ"),
            sections: [
                {
                    name: smeBetriebHaft,
                    line: smeHaft,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: smeSach,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: smeGewGebaeude,
                            line: smeSach,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeInhalt,
                            line: smeSach,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeErtrag,
                            line: smeSach,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeKleinBU,
                            line: smeSach,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeBetriebsschliessung,
                            line: smeSach,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: smeWohngebaeude,
                    line: smeSach,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: () =>
                        config.FLAGS &&
                        config.FLAGS.includes("SME_WOHHNGEBAEUDE"),
                },
                {
                    name: smeMaschinenFahrbar,
                    line: smeTech,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: () =>
                        config.FLAGS &&
                        config.FLAGS.includes("SME_MASCHINEN_FAHRBAR"),
                },
                {
                    name: smeMaschinenStationaer,
                    line: smeTech,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: () =>
                        config.FLAGS &&
                        config.FLAGS.includes("SME_MASCHINEN_STATIONAER"),
                },
                {
                    name: smeElektronik,
                    line: smeTech,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: () =>
                        config.FLAGS && config.FLAGS.includes("ELEKTRONIK"),
                },
                {
                    name: smeBauherren,
                    line: smeHaft,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: smeVeranstalter,
                    line: smeHaft,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: smeHausUndGrund,
                    line: smeHaft,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: smeRechtsschutz,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: smeRechtsschutzPaket,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeRechtsschutzPaketFuerArzteApothekerUndHeilberufe,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeRechtsschutzPaketFuerVereine,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeRechtsschutzPaketFuerKfzGewerbeUndFahrschulen,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeRechtsschutzPaketFuerFuhrUndTransportbetriebe,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeFirmenRechtsschutz,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smePrivatRechtsschutz,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeVerkehrsRechtsschutzAbs1,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeVerkehrsRechtsschutzAbs3,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeLandwirtschaftsUndVerkehrsRechtsschutz,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeImmobilienRechtsschutz,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: smeSpezialStrafRechtsschutz,
                            line: smeRechtsschutz,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: smeAutoinhalt,
                    line: smeAutoinhalt,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: smeFrachtfuehrer,
                    line: smeFrachtfuehrer,
                    category: sme,
                    application: "SME",
                    riskName: riskPerson,
                    multi: true,
                    visibility: null,
                },
                {
                    name: smeWarentransportEinmalig,
                    line: smeWarentransportEinmalig,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: smeWarentransportJahresvertrag,
                    line: smeWarentransportJahresvertrag,
                    category: sme,
                    application: "SME",
                    riskName: riskSach,
                    multi: true,
                    visibility: null,
                },
                {
                    name: smeGruppenunfall,
                    line: smeGruppenunfall,
                    category: sme,
                    application: "SME",
                    riskName: "Risiko",
                    multi: true,
                    visibility: null,
                },
                {
                    name: smeTech,
                    multi: true,
                    visibility: () => false,
                    sections: [
                        {
                            name: smeBauleistung,
                            line: smeTech,
                            category: sme,
                            application: "SME",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
            ],
        },
        {
            name: sonstige,
            multi: true,
            visibility: null,
            sections: [
                {
                    name: bav,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "fkBavDirektversicherung",
                                displayName: "Direktversicherung",
                                printName: "Direktversicherung",
                            },
                            line: bav,
                            category: leben,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "fkBavPensionszusage",
                                displayName: "Pensionszusage",
                                printName: "Pensionszusage",
                            },
                            line: bav,
                            category: leben,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
                {
                    name: dritt,
                    multi: true,
                    visibility: null,
                    sections: [
                        {
                            name: {
                                key: "drittIdealSterbegeld",
                                displayName: "IDEAL Sterbegeld",
                                printName: "IDEAL Sterbegeld",
                            },
                            line: dritt,
                            category: dritt,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "drittIdealPflegeRente",
                                displayName: "IDEAL Pflege-Rente",
                                printName: "IDEAL Pflege-Rente",
                            },
                            line: dritt,
                            category: dritt,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "drittDKVPflegeZusatz",
                                displayName: "DKV Pflege-Zusatzversicherung",
                                printName: "DKV Pflege-Zusatzversicherung",
                            },
                            line: dritt,
                            category: dritt,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "drittDKVKrankenzusatz",
                                displayName: "DKV Krankenzusatzversicherung",
                                printName: "DKV Krankenzusatzversicherung",
                            },
                            line: dritt,
                            category: dritt,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "drittEagleKrankheitsschutzbrief",
                                displayName: "EAGLE STAR Krankheitsschutzbrief",
                                printName: "EAGLE STAR Krankheitsschutzbrief",
                            },
                            line: dritt,
                            category: dritt,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "drittEagleRisikolebenTop",
                                displayName: "EAGLE STAR Risikoleben Top",
                                printName: "EAGLE STAR Risikoleben Top",
                            },
                            line: dritt,
                            category: dritt,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "drittEagleRisikolebenBasic",
                                displayName: "EAGLE STAR Risikoleben Basic",
                                printName: "EAGLE STAR Risikoleben Basic",
                            },
                            line: dritt,
                            category: dritt,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "investmentDirekt34fDWSDrittfonds",
                                displayName:
                                    "Investment-Direkt (34f) - DWS und Drittfonds",
                                printName:
                                    "Investment-Direkt (34f) - DWS und Drittfonds",
                            },
                            line: dritt,
                            category: dritt,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                        {
                            name: {
                                key: "drittSonstige",
                                displayName: "Sonstige Anbieter",
                                printName: "Sonstige Anbieter",
                            },
                            line: dritt,
                            category: dritt,
                            application: "FK",
                            riskName: riskSach,
                            multi: true,
                            visibility: null,
                        },
                    ],
                },
            ],
        },
    ],
};

export const initialCategoryByApplication = {
    ZAS: productDefinitions.sections[0],
    WebLife: productDefinitions.sections[1],
    default: productDefinitions.sections[0],
};

export function getInitialCategory(application) {
    return (
        initialCategoryByApplication[application] ||
        initialCategoryByApplication.default
    );
}

export const productsByKey = createProductsByKey(productDefinitions);
